import React, { Component } from "react";
import AppcategoryBean from "../data/bean/app_claim_status_bean";
import AppHeaderBean from "../data/bean/app_header_bean";
import AppTableStatus from "../ui/component/app_table_status/app_table_status";
import GeneralBloc from "./general_bloc";
import FormWebServices from "../service/form_web_services";
import AuthBloc from "./auth_bloc";
import Config from "../Config";
import StateMaster from "../data/constant/state_master";
import CityMaster from "../data/constant/city_master";
import CountryMaster from "../data/constant/country_master";

import { ReactComponent as DownloadIcon } from "../Download.svg";
import GeneralWebService from "../service/general_web_service";
import ProposalServices from "../service/proposal_web_services";
import LanguageBloc from "./language_bloc";
import Labels from "../ui/constant/labels";
import UtilBloc from "./util_bloc";

class FormsBloc extends Component {

  static async getFormDataTable(
    entity,
    dateFilter,
    fromDate,
    toDate,
    regions,
    page,
    searchBy,
    keyword
  ) {
    let token = "";
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }

    let response = await FormWebServices.getForm(
      token,
      entity,
      page,
      null,
      null,
      regions,
      searchBy,
      keyword
    );

    let dataSet = {};
    if (response.success) {
      dataSet = await GeneralBloc.getListingTable(response, "form");
    }
    let result = {
      dataCollumn: dataSet.columnTable || [],
      dataClaim: dataSet.data || [],
      totalData: dataSet.total || [],
      //categories:response.data.criFormPage.form[1].typeConfig.values
    };
    return result;
  }

  static async getOccupationList() {
    let response = await FormWebServices.getOccupationList();
    return response;
  }

  static async getOccupationNameByCode(code) {
    if (code) {
      let response = await FormWebServices.getOccupationList();
      let occupation = response.data.filter((item) => item.code === code);
      return occupation[0].reference1;
    } else {
      return '';
    }
  }

  static async getOccupationCodeByName(name) {
    if (name) {
      let response = await FormWebServices.getOccupationList();
      let occupation = response.data.filter((item) => item.reference1.toUpperCase() === name.toUpperCase());
      return occupation?.length > 0 ? occupation[0].value : '';
    } else {
      return '';
    }
  }

  static async getNatureOfBusiness(occ) {
    let response = await FormWebServices.getNobList(occ);
    return response;
  }

  static async getNobNameByCode(occ, code) {
    if (code) {
      let response = await this.getNatureOfBusiness(occ);
      let nob = response.data.filter((item) => item.code === code);
      return nob[0]?.reference1 || '';
    } else {
      return '';
    }
  }

  static async getNobCodeByName(occ, name) {
    if (name) {
      let response = await this.getNatureOfBusiness(occ);
      let nob = response.data.filter((item) => item.reference1.toUpperCase() === name.toUpperCase());
      return nob?.length > 0 ? nob[0].value : '';
    } else {
      return '';
    }
  }

  static async getOccupationClassList(occ, nob) {
    let response = await FormWebServices.getOccupationClass(occ, nob);
    return response;
  }

  static async getOccupationCodeList(occ, nob) {
    let response = await FormWebServices.getOccupationCode(occ, nob);
    return response;
  }

  static async getCountryList() {
    let response = await FormWebServices.getMasterRecord('COUNTRY_FWD');
    return response;
  }

  static async getStateList(user = 'agent') {
    let response = await FormWebServices.getMasterRecord('STATE_FWD', user);
    return response;
  }

  static async getCityList(state) {
    let response = await FormWebServices.getCityMasterRecord('CITY_FWD', state);
    return response;
  }

  static async getPostcodeList(city, state) {
    let response = await FormWebServices.getPostcodeMasterRecord('POSTCODE_FWD', city, state);
    return response;
  }

  static async getBankList() {
    let response = await FormWebServices.getMasterRecord('BANK_FWD');
    let data = response;
    data.data.map((item, idx) => {
      item.value = idx + 1
    })
    return data;
  }


  static async getFinanceInstituteList() {
    let response = await FormWebServices.getMasterRecord('FINANCE_INST');
    let data = response;
    return data;
  }

  static async getAnnualIncomeRangeList() {
    let response = await FormWebServices.getMasterRecord('ANNUAL_INCOME_RANGE');
    let data = response;
    return data;
  }

  static async getAdditionalIDList() {
    let response = await FormWebServices.getMasterRecord('ADD_ID_TYPE');
    let data = response;
    return data;
  }

  static async getAdditionalIDNameByCode(code) {
    let additionalIDList = await this.getAdditionalIDList();
    let additionalIDCode = additionalIDList.data.filter((item) => item.code === code);
    return additionalIDCode[0].reference1;
  }

  static async getAnnualIncomeRangeNameByCode(code) {
    let annualIncomeRangeList = await this.getAnnualIncomeRangeList();
    let annualIncomeRangeCode = annualIncomeRangeList.data.filter((item) => item.code === code);
    return annualIncomeRangeCode[0].reference1;
  }

  static async getFinanceInstituteNameByCode(code) {
    let financeInstituteList = await this.getFinanceInstituteList();
    let financeInstituteCode = financeInstituteList.data.filter((item) => item.code === code);
    return financeInstituteCode[0].reference1;
  }

  static async getBankNameByCode(code) {
    let bankList = await this.getBankList();
    let bankCode = bankList.data.filter((item) => item.code === code);
    return bankCode[0].reference1;
  }

  static async getOccupationNameByCode(code) {
    let occList = await this.getOccupationList();
    let occName = occList.data.filter((item) => item.code === code);
    return occName?.length > 0 ? UtilBloc.capitalize(occName[0].reference1) : '';
  }

  static async getNatureOfBusinessByOcc(occCode, nob) {
    let list = await this.getNatureOfBusiness(occCode);
    let natureOfBusiness = list.data.filter((item) => item.code === nob);
    return natureOfBusiness?.length > 0 ? UtilBloc.capitalize(natureOfBusiness[0].reference1) : '';
  }

  static async getSalutationList() {
    let response = await FormWebServices.getMasterRecord('SALUTATION_FWD');
    return response;
  }

  static getDummyFormsStatuses() {
    return [
      new AppcategoryBean("Received.svg", "Submitted", 30),
      new AppcategoryBean("InProgress.svg", "In Progress", 30),
      new AppcategoryBean("Approved.svg", "Approved", 10),
      new AppcategoryBean("Closed.svg", "Closed", 10),
      new AppcategoryBean("Rejected.svg", "Rejected", 30),
      new AppcategoryBean("Mixed Decisions.svg", "Mixed Decisions", 30),
    ];
  }

  static getCollumnTable() {
    return [
      {
        title: "File Name",
        dataIndex: "fileName",

        // specify the condition of filtering result
        // here is that finding the name started with `value`
      },
      {
        title: "Category",
        dataIndex: "category",
      },
      {
        title: "Last Updated",
        dataIndex: "lastUpdated",
      },
      {
        title: "Size",
        dataIndex: "size",
      },
      {
        title: "Action",
        dataIndex: "action",
      },
    ];
  }
  static getDummyFormsDataTable() {
    return [
      {
        key: "1",
        fileName: "Absolute Assignment",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "2",
        fileName: "Assignment of takaful certificate as collateral",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "3",
        fileName: "Cancellation/surrender form",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "4",
        fileName: "Change request form",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "5",
        fileName: "Investment form",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "6",
        fileName: "Nomination",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "7",
        fileName: "PDPA data access form",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "8",
        fileName: "Personal health delcaration form",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "9",
        fileName: "Reassignment",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "10",
        fileName: "Reassignment 2",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
      {
        key: "11",
        fileName: "Reassignment 3",
        category: (
          <AppTableStatus
            statusName="Takaful certificate servicing"
            status={"grey"}
          />
        ),
        lastUpdated: "25/01/2022",
        size: "1 MB",
        action: (
          <div className="pl-3">
            <DownloadIcon />,
          </div>
        ),
      },
    ];
  }
  static getDummyUserData() {
    return new AppHeaderBean(
      "Janice Wong",
      "Premier Financial Manager",
      "HSBC Amanah Takaful"
    );
  }

  static async getNobListing(occupationCode) {
    let resp = await ProposalServices.getNobListing(occupationCode);
    let data = [];
    let list = resp.data;
    let language = LanguageBloc.getSelectedLanguage();
    //Sort by Alphabetical order
    if (language == Config.locale.en) {
      list.sort((a, b) => a.reference1.localeCompare(b.reference1));
    } else {
      list.sort((a, b) => a.reference2.localeCompare(b.reference2));
    }
    list.map((item) => {
      if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
        data.push({
          description: item.reference1,
          description1: item.reference2,
          code: item.code,
        });
      }
    });

    if (resp.success) {
      return data;
    } else {
      return [];
    }
  }

  static async getOccupationClass(occupationCode, NOBCode) {
    let resp = await ProposalServices.getOccupationClass(
      occupationCode,
      NOBCode
    );

    if (resp.success) {
      return resp.data;
    } else {
      return [];
    }
  }

  static getProcessedValue(value, list) {
    if (value != null) {
      let currentLang = LanguageBloc.getSelectedLanguage();
      let returnValue = value;
      let dataList = list;
      dataList.map((item) => {
        if (value === item.description || value === item.description1) {
          if (currentLang == "EN") {
            returnValue = item.description;
          } else {
            returnValue = item.description1;
          }
        }
      });
      return returnValue;
    }
  }

  static checkFileNameExtension(filename) {
    if (
      !filename.endsWith(".jpg") &&
      !filename.endsWith(".png") &&
      !filename.endsWith(".jpeg") &&
      !filename.endsWith(".pdf") &&
      !filename.endsWith(".JPG") &&
      !filename.endsWith(".PNG") &&
      !filename.endsWith(".JPEG") &&
      !filename.endsWith(".PDF")
    ) {
      return;
    }
  }

  static getFormFieldsFromConfig(formSetup, fieldsConfig) {
    let formFields = [];
    if (formSetup && formSetup.length > 0) {
      formSetup.map((ev, index) => {
        if (
          ev.id == fieldsConfig[ev.id] ||
          ev.id.toUpperCase() == fieldsConfig[ev.id]
        ) {
          formFields.push(fieldsConfig[ev.id]);
        }
      });
      return formFields;
    } else {
      return [];
    }
  }

  //Get postcode by state
  static getPostcodeByCode(code) {
    return CityMaster.cities.filter((item) => (item.stateCode == code));
  }

  //Get city by code
  static getCityByZipCode(zipCode) {
    return CityMaster.cities.filter((item) => (item.postCode == zipCode));
  }

  //Get state by code
  static getStateByCode(code) {
    for (let i = 0; i < StateMaster.states.length; i++) {
      let item = StateMaster.states[i];
      if (item.stateCode == code) return item;
    }
    return null;
  }

  //Get stateCode by name
  static getStateCodeByName(stateName) {
    if (!UtilBloc.isNullOrEmpty(stateName)) {
      let name = stateName.toUpperCase();

      for (let i = 0; i < StateMaster.states.length; i++) {
        let item = StateMaster.states[i];
        if (item.stateName == name) return item;
      }
      return null;
    } else {
      return '';
    }

  }

  //Get states
  static getStateSelections() {
    return StateMaster.states;
  }

  //Get cities
  static getCitySelections() {
    return CityMaster.cities;
  }

  //Get cities
  static getCityByStateCodeSelections(statecode) {
    let cities = CityMaster.cities;
    cities = cities.filter((item) => item.stateCode == statecode);
    return cities;
  }

  //Get countries
  static getCountrySelections(other) {
    if (other == true) {
      return CountryMaster.othercountries;
    } else {
      return CountryMaster.countries;
    }
  }

  //Get countries
  static getCountryWithoutMalaysia() {
    let countries = CountryMaster.othercountries;
    countries = countries.filter((item) => item.value !== "MYS"); // original is item.code
    return countries;
  }

  //Get country by code
  static getCountryByCode(code) {
    for (let i = 0; i < CountryMaster.othercountries.length; i++) {
      let item = CountryMaster.othercountries[i];
      if (item.value == code) return item; // original is item.code
    }
    return null;
  }

  //Get country code by name
  static getCountryCodeByName(name) {
    if (!UtilBloc.isNullOrEmpty(name)) {
      let countryName = name.toUpperCase();
      for (let i = 0; i < CountryMaster.othercountries.length; i++) {
        let item = CountryMaster.othercountries[i];
        if (item.label == countryName) return item; // original is item.code
      }
      return null;
    } else {
      return '';
    }

  }

  static sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  static async getMasterDataWithCode(param) {
    let newList = [];
    let language = LanguageBloc.getSelectedLanguage();
    let resp = await GeneralWebService.getMasterDataWithCode(param);
    if (resp.success) {
      let list = resp.data;
      //Sort by Alphabetical order
      if (language == Config.locale.en) {
        list.sort((a, b) => a.reference1.localeCompare(b.reference1));
      } else {
        list.sort((a, b) => a.reference2.localeCompare(b.reference2));
      }

      let others = null;

      list.map((item) => {
        if (item.status == "ACTIVE" && item.reference1 && item.reference2) {
          if (item.code != "Others") {
            newList.push({
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              value: item.value,
            });
          } else {
            others = {
              description: item.reference1,
              description1: item.reference2,
              description2: item.reference3,
              code: item.code,
              value: item.value,
            };
          }
        }
      });
      if (others) {
        newList.push(others);
      }
    }

    return newList;
  }

  static getFinancialDetailsConfig() {
    return {
      formName: Labels.LBL_STEP2_FINANCIAL_DETAILS,
      formDesc: Labels.LBL_STEP2_FINANCIAL_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.quotation_takaful_details}`,
      backStep: `/${Config.context}/${Config.routes.generic.quotation_personal_details}`,
      closeStep: `/${Config.context}/${Config.routes.generic.quotation}`,
      fields: {
        financingBank: "financingBank",
        financingAccNo: "financingAccNo",
        bankRefNo: "bankRefNo",
        eligibleB40: "eligibleB40",
        financingAmount: "financingAmount",
        financingPercentage: "financingPercentage",
        coveredFinancingAmount: "coveredFinancingAmount",
        assuredBankRate: "assuredBankRate",
        financingPeriod: "financingPeriod",
        defermentPeriod: "defermentPeriod",
        contributionType: "contributionType",
      },
      formConfig: [
        {
          id: "financingBank",
        },
        {
          id: "financingAccNo",
        },
        {
          id: "bankRefNo",
        },
        {
          id: "eligibleB40",
        },
        {
          id: "financingAmount",
        },
        {
          id: "financingPercentage",
        },
        {
          id: "coveredFinancingAmount",
        },
        {
          id: "assuredBankRate",
        },
        {
          id: "contributionType",
        },
        {
          id: "financingPeriod",
        },
        {
          id: "defermentPeriod",
        },
      ],
    };
  }

  static getProvideDetailsConfig() {
    return {
      formName: Labels.LBL_STEP1_PROVIDE_DETAILS,
      formDesc: Labels.LBL_STEP1_PROVIDE_DETAILS_DESC,
      nextStep: `/${Config.context}/${Config.routes.generic.proposal_upload_documents}`,
      backStep: `/${Config.context}/${Config.routes.generic.select_quotation}`,
      closeStep: `/${Config.context}/${Config.routes.generic.proposal}`,
      personalDetails: {
        formName: "Representative Details",
        fields: {
          representativeName: "representativeName",
          staffId: "staffId",
          representativeTakafulCode: "representativeTakafulCode",
          financialInstitutionCode: "financialInstitutionCode",
          referralId: "referralId",
          dateOfQuotation: "dateOfQuotation",

          name: "name",
          gender: "gender",
          title: "title",
          typeId: "typeId",
          otherTypeId: "otherTypeId",
          idNo: "idNo",
          otherIdNo: "otherIdNo",
          dob: "dob",

          maritalStatus: "maritalStatus",
          race: "race",
          religion: "religion",
          placeOfBirth: 'placeOfBirth',
          placeOfBirth2: 'placeOfBirth2',
          placeOfBirth3: 'placeOfBirth3',
          isLivingInMalaysia: "isLivingInMalaysia",
          country: "country",
          state: 'state',
          city: 'city',
          corrCountry: "corrCountry",
          corrState: 'corrState',
          corrPostcode: 'corrPostcode',
          corrCity: 'corrCity',
          correspondenceAddress: "correspondenceAddress",
          correspondenceAddress2: "correspondenceAddress2",
          correspondenceAddress3: "correspondenceAddress3",
          // isPermamentAddressCorrespondenceAddress: "isPermamentAddressCorrespondenceAddress",
          // permanentAddress: "permanentAddress",
          isResidentialAddressCorrespondenceAddress: "isResidentialAddressCorrespondenceAddress",
          residentialAddress: "residentialAddress",
          residentialAddress2: "residentialAddress2",
          residentialAddress3: "residentialAddress3",
          residentialState: "residentialState",
          residentialCity: "residentialCity",
          residentialPostcode: "residentialPostcode",
          isMalaysian: "isMalaysian",
          foreignCountry: "foreignCountry",
          exactDuties: 'exactDuties',
          annualIncome: 'annualIncome',
          exactAnnualIncome: 'exactAnnualIncome',
          height: "height",
          weight: "weight",
          smoked: "smoked",
          yearsOfSmoked: "yearsOfSmoked",
          typeCigarettes: "typeCigarettes",
          sticksPerDay: "sticksPerDay",
          occupation: "occupation",
          nob: "nob",
          occupationClass: "occupationClass",
          countryCodeMobileNumber: "countryCodeMobileNumber",
          mobileNo: "mobileNo",
          countryCodeOfficeNumber: "countryCodeOfficeNumber",
          officePhoneNo: "officePhoneNo",
          homePhoneNo: "homePhoneNo",
          email: "email",
          companyName: "companyName",
          companyAddress: "companyAddress",
          companyAddress2: "companyAddress2",
          companyAddress3: "companyAddress3",
          companyCountry: "companyCountry",
          companyState: "companyState",
          companyPostcode: "companyPostcode",
          companyCity: "companyCity",
          preferContactMode: 'preferContactMode',
        },
        formConfig: [
          {
            id: "representativeName",
          },
          {
            id: "staffId",
          },
          {
            id: "representativeTakafulCode",
          },
          {
            id: "financialInstitutionCode",
          },
          {
            id: "referralId",
          },
          {
            id: "dateOfQuotation",
          },
          {
            id: "name",
          },
          {
            id: "gender",
          },
          {
            id: "title",
          },
          {
            id: "typeId",
          },
          {
            id: "otherTypeId",
          },
          {
            id: "idNo",
          },
          {
            id: "otherIdNo",
          },
          {
            id: "dob",
          },
          {
            id: "maritalStatus",
          },
          {
            id: "race",
          },
          {
            id: "religion",
          },
          {
            id: "currentlyLivingInMalaysia",
          },
          {
            id: "currentLivingCountry",
          },
          {
            id: "currentlyLivingAddress",
          },
          {
            id: "malaysian",
          },
          {
            id: "foreignCountry",
          },
          {
            id: "height",
          },
          {
            id: "weight",
          },
          {
            id: "smoked",
          },
          {
            id: "yearsOfSmoked",
          },
          {
            id: "typeCigarettes",
          },
          {
            id: "sticksPerDay",
          },
          {
            id: "occupation",
          },
          {
            id: "nob",
          },
          {
            id: "occupationClass",
          },
          {
            id: "countryCodeMobileNumber",
          },
          {
            id: "mobileNumber",
          },
          {
            id: "officePhoneNumber",
          },
          {
            id: "homePhoneNumber",
          },
          {
            id: "email",
          },
          {
            id: "companyName",
          },
          {
            id: "companyAddress",
          },
        ],
      },
      mortgageDetails: {
        formName: "",
        fields: {
          financingBank: "financingBank",
          refNo: "refNo",
          financed: "financed",
          financingAmount: "financingAmount",
          benefit: "benefit",
          contributionAmount: "contributionAmount",
          initialSumCovered: "initialSumCovered",
          loanTerm: "loanTerm",
          defermentPeriod: "defermentPeriod",
          coverageTerm: "coverageTerm",
          criticalIllnessSumCovered: "criticalIllnessSumCovered",
        },
        formConfig: [
          {
            id: "financingBank",
          },
          {
            id: "refNo",
          },
          {
            id: "financed",
          },
          {
            id: "financingAmount",
          },
          {
            id: "benefit",
          },
          {
            id: "contributionAmount",
          },
          {
            id: "initialSumCovered",
          },
          {
            id: "loanTerm",
          },
          {
            id: "defermentPeriod",
          },
          {
            id: "coverageTerm",
          },
          {
            id: "criticalIllnessSumCovered",
          },
        ],
      },
      creditCardDetails: {
        formName: "",
        fields: {
          cardHolderName: "cardHolderName",
          creditCardNo: "creditCardNo",
          creditCardType: "creditCardType",
          creditCardExpiryDate: "creditCardExpiryDate",
          issueBankCode: "issueBankCode",
        },
        formConfig: [
          {
            id: "cardHolderName",
          },
          {
            id: "creditCardNo",
          },
          {
            id: "creditCardType",
          },
          {
            id: "creditCardExpiryDate",
          },
          {
            id: "issueBankCode",
          },
        ],
      },
      healthStatement: {
        formName: "",
        fields: {
          isReceivedTreatment: "isReceivedTreatment",
          isContinuouslyReceiveMedication: "isContinuouslyReceiveMedication",
          isAdvisedMedicalTest: "isAdvisedMedicalTest"
        },
        formConfig: [
          {
            id: "isReceivedTreatment",
          },
          {
            id: "isContinuouslyReceiveMedication",
          },
          {
            id: "isAdvisedMedicalTest",
          },
        ],
      },
      payorInformation: {
        formName: "",
        fields: {
          isPayorPersonCovered: "isPayorPersonCovered",
          relationshipToPersonCovered: "relationshipToPersonCovered",
          specifyRelationship: "specifyRelationship",
          name: "name",
          gender: "gender",
          idNo: "idNo",
          idType: "idType",
          addIDType: "addIDType",
          oldIcNo: "oldIcNo",
          birthCertNo: "birthCertNo",
          otherIdNo: "otherIdNo",
          dob: "dob",

          placeOfBirth: 'placeOfBirth',
          country: "country",
          state: 'state',
          city: 'city',
          corrCountry: "corrCountry",
          corrState: 'corrState',
          corrPostcode: 'corrPostcode',
          corrCity: 'corrCity',
          correspondenceAddress: "correspondenceAddress",
          correspondenceAddress2: "correspondenceAddress2",
          correspondenceAddress3: "correspondenceAddress3",
          isResidentialAddressCorrespondenceAddress: "isResidentialAddressCorrespondenceAddress",
          residentialAddress: "residentialAddress",
          residentialAddress2: "residentialAddress2",
          residentialAddress3: "residentialAddress3",
          residentialState: "residentialState",
          residentialCity: "residentialCity",
          residentialPostcode: "residentialPostcode",
          nationality: "nationality",
          foreignCountry: "foreignCountry",
          exactDuties: 'exactDuties',
          annualIncome: 'annualIncome',
          exactAnnualIncome: 'exactAnnualIncome',
          occupation: "occupation",
          natureBusiness: "natureBusiness",
          occupationClass: "occupationClass",
          mobileNo: "mobileNo",
          officePhoneNo: "officePhoneNo",
          homePhoneNo: "homePhoneNo",
          email: "email",
          companyName: "companyName",
          companyAddress: "companyAddress",
          companyAddress2: "companyAddress2",
          companyAddress3: "companyAddress3",
          companyCountry: "companyCountry",
          companyState: "companyState",
          companyPostcode: "companyPostcode",
          companyCity: "companyCity",
        },
        formConfig: [
          {
            id: "representativeName",
          },
          {
            id: "staffId",
          },
          {
            id: "isPayorPersonCovered",
          },
          {
            id: "relationshipWithPersonCovered",
          },
          {
            id: "specifyRelationship",
          },
          {
            id: "name",
          },
          {
            id: "typeId",
          },
          {
            id: "otherTypeId",
          },
          {
            id: "idNo",
          },
          {
            id: "otherIdNo",
          },
          {
            id: "addIDType",
          },
          {
            id: "oldIcNo",
          },
          {
            id: "birthCertNo",
          },
          {
            id: "dob",
          },
          {
            id: "currentlyLivingInMalaysia",
          },
          {
            id: "currentLivingCountry",
          },
          {
            id: "currentlyLivingAddress",
          },
          {
            id: "nationality",
          },
          {
            id: "occupation",
          },
          {
            id: "nob",
          },
          {
            id: "occupationClass",
          },
          {
            id: "countryCodeMobileNumber",
          },
          {
            id: "mobileNumber",
          },
          {
            id: "officePhoneNumber",
          },
          {
            id: "email",
          },
          {
            id: "companyName",
          },
          {
            id: "companyAddress",
          },
        ]
      },
      directCredit: {
        formName: "",
        fields: {
          accHolderName: "accHolderName",
          bankAccNo: "bankAccNo",
          bankName: "bankName",
          isTermsAndConditionChecked: "isTermsAndConditionChecked",
        },
        formConfig: [
          {
            id: "accHolderName",
          },
          {
            id: "bankAccNo",
          },
          {
            id: "bankName",
          },
          {
            id: "isTermsAndConditionChecked",
          },
        ],
      },
      extendedHealth: {
        formName: "",
        fields: {
          height: "height",
          weight: "weight",
          isSmoker: "isSmoker",
          isDiagnosedDisease: "isDiagnosedDisease",
          isConsultOrTreatment: "isConsultOrTreatment",
          isInvestigateOrOperation: "isInvestigateOrOperation",
          hasGeneticDisorder: "hasGeneticDisorder",
          isPregnant: "isPregnant",
          pregnancyMonth: "pregnancyMonth",
        },
        formConfig: [
          {
            id: "height",
          },
          {
            id: "weight",
          },
          {
            id: "isSmoker",
          },
          {
            id: "isDiagnosedDisease",
          },
          {
            id: "isConsultOrTreatment",
          },
          {
            id: "isInvestigateOrOperation",
          },
          {
            id: "hasGeneticDisorder",
          },
          {
            id: "isPregnant",
          },
          {
            id: "pregnancyMonth",
          },
        ],
      },
      eCredit: {
        formName: "",
        fields: {
          bankAccountNo: "bankAccountNo",
          financingBank: "financingBank",
          categoryOfBank: "categoryOfBank",
          agreeChecked: "agreeChecked",
        },
        formConfig: [
          {
            id: "bankAccountNo",
          },
          {
            id: "financingBank",
          },
          {
            id: "categoryOfBank",
          },
          {
            id: "agreeChecked",
          },
        ],
      },
      foreignQues: {
        formName: "",
        fields: {
          arriveDate: "arriveDate",
          stayDuration: "stayDuration",
          statusInMalaysia: "statusInMalaysia",
          otherStatusInMalaysia: "otherStatusInMalaysia",
          positionNduties: "positionNduties",
          isBank: "isBank",
          isBankDetails: "isBankDetails",
          isProperty: "isProperty",
          isPropertyDetails: "isPropertyDetails",
          isInvestment: "isInvestment",
          isInvestmentDetails: "isInvestmentDetails",
          isBusiness: "isBusiness",
          isBusinessDetails: "isBusinessDetails",
          isRelatives: "isRelatives",
          isDunHave: "isDunHave",
          isRelativesDetails: "isRelativesDetails",
          isSpouseMalaysian: "isSpouseMalaysian",
          spouseOccupation: "spouseOccupation",
          spouseNationality: "spouseNationality",
          familyMember: "familyMember",
          isTravel: "isTravel",
          travelFreq: "travelFreq",
          reasonForCert: "reasonForCert",
        },

      },
      ResidentialQues: {
        formName: "",
        fields: {
          stayDuration: "stayDuration",
          residenceOrTravelAddress: "residenceOrTravelAddress",
          residenceOrTravelCountry: "residenceOrTravelCountry",
          residenceOrTravelState: "residenceOrTravelState",
          residenceOrTravelPostcode: "residenceOrTravelPostcode",
          residenceOrTravelCity: "residenceOrTravelCity",
          travelStayDuration: "travelStayDuration",
          isFirstEMploymentReason: "isFirstEMploymentReason",
          notFisrtEmployment: "notFisrtEmployment",
          isStayThroughout: "isStayThroughout",
          notStayThroughoutAddress: "notStayThroughoutAddress",
          typeOfStay: "typeOfStay",
          otherAccommodationType: "otherAccommodationType",
          acommodationLocated: "acommodationLocated",
          liveWorkCondition: "liveWorkCondition",
          politicalSituation: "politicalSituation",
          //form end
        }
      },
      OilGasQues: {
        formName: "",
        fields: {
          //form start
          occupation: "occupation",
          exactDuties: "exactDuties",
          workingDuration: "workingDuration",
          isHazardousDuties: "isHazardousDuties",
          isJobScopeHeavy: "isJobScopeHeavy",
          isJobScopeChemical: "isJobScopeChemical",
          isJobScopeEquipment: "isJobScopeEquipment",
          isJobScopeExplosives: "isJobScopeExplosives",
          isJobScopeVoltages: "isJobScopeVoltages",
          isJobScopeUnderwater: "isJobScopeUnderwater",
          isJobScopeNo: "isJobScopeNo",
          isAccident: "isAccident",
          isAccidentDetails: "isAccidentDetails",
          rigLocation: "rigLocation",
          travelFreqToRig: "travelFreqToRig",
          isHelicopter: "isHelicopter",
          isOthers: "isOthers",

          hazardousDetails: "hazardousDetails",
          isJobScopeHeavyDetails: "isJobScopeHeavyDetails",
          isJobScopeChemicalDetails: "isJobScopeChemicalDetails",
          isJobScopeEquipmentDetails: "isJobScopeEquipmentDetails",
          isJobScopeExplosivesDetails: "isJobScopeExplosivesDetails",
          isJobScopeVoltagesDetails: "isJobScopeVoltagesDetails",
          isJobScopeUnderwaterDetails: "isJobScopeUnderwaterDetails",
          helicopterToRigDuration: "helicopterToRigDuration",
          helicopterToRigFreq: "helicopterToRigFreq",
          otherDetails: "otherDetails",
        }
      },
      GeneralOccupation: {
        formName: "",
        fields: {
          //form start
          occupation: "occupation",
          isJobScopeHeavy: "isJobScopeHeavy",
          isJobScopeHighOrLow: "isJobScopeHighOrLow",
          isJobScopeChemical: "isJobScopeChemical",
          isJobScopeVoltages: "isJobScopeVoltages",
          isJobScopeEquipment: "isJobScopeEquipment",
          isJobScopeVessels: "isJobScopeVessels",
          isJobScopeTravelAirCraft: "isJobScopeTravelAirCraft",
          isJobScopeEnv: "isJobScopeEnv",
          isJobScopeNo: "isJobScopeNo",
          isAccident: "isAccident",
          workingDuration: "workingDuration",
          isHealtAffectedByOcc: "isHealtAffectedByOcc",
          isChangeWork: "isChangeWork",

          hazardousDetails: "hazardousDetails",
          isJobScopeHeavyDetails: "isJobScopeHeavyDetails",
          isJobScopeHighOrLowDetails: "isJobScopeHighOrLowDetails",
          isJobScopeChemicalDetails: "isJobScopeChemicalDetails",
          isJobScopeVoltagesDetails: "isJobScopeVoltagesDetails",
          isJobScopeEquipmentDetails: "isJobScopeEquipmentDetails",
          isJobScopeVesselsDetails: "isJobScopeVesselsDetails",
          isJobScopeTravelAirCraftDetails: "isJobScopeTravelAirCraftDetails",
          isJobScopeEnvDetails: "isJobScopeEnvDetails",
          isAccidentDetails: "isAccidentDetails",
          isChangeWorkNatureDetails: "isChangeWorkNatureDetails",
        }
      },
    }
  }
}

export default FormsBloc;
